export const FEATURE_FLAG_FEED_CONTENT = !!JSON.parse(import.meta.env.VITE_FEATURE_FLAG_FEED_CONTENT)
export const FEATURE_FLAG_MAINTENANCE_MODE = !!JSON.parse(import.meta.env.VITE_FEATURE_FLAG_MAINTENANCE_MODE)
export const FEATURE_FLAG_MODULE_CUSTOMER_LIST = !!JSON.parse(import.meta.env.VITE_FEATURE_FLAG_MODULE_CUSTOMER_LIST)
